(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function () {
            return factory();
        });
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else{
        root.config=factory();
    }
})(this,function(module){
    'use strict'
	var hasLoadConfig = module && module.config && typeof module.config === "function";
	var STRING="string";
	return function(){
		var conf=hasLoadConfig && module.config() || "",
			config={};
		if(typeof conf==='object'){
			config=conf;
		}
		config.level= config.level || (typeof conf===STRING && conf) || (conf.level) || 'none';
		return config;
	}
});